import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceCard = ({ service }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'available':
        return 'text-success bg-success/10';
      case 'limited':
        return 'text-warning bg-warning/10';
      case 'unavailable':
        return 'text-error bg-error/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'available':
        return 'พร้อมให้บริการ';
      case 'limited':
        return 'บริการจำกัด';
      case 'unavailable':
        return 'ปิดบริการชั่วคราว';
      default:
        return 'ไม่ทราบสถานะ';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-government hover:shadow-government-lg transition-government">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className={`${service?.icon === 'Damrongtham' ? 'w-16 h-16 bg-white border-2 border-blue-200' : 'w-12 h-12 bg-primary/10'} rounded-lg flex items-center justify-center`}>
            {service?.icon === 'Damrongtham' ? (
              <img 
                src="/assets/images/damrongtham-logo.jpg" 
                alt="ศูนย์ดำรงธรรม 1567" 
                className="w-12 h-12"
              />
            ) : (
              <Icon name={service?.icon} size={24} className="text-primary" />
            )}
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">
              {service?.title}
            </h3>
            <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(service?.status)}`}>
              <div className={`w-2 h-2 rounded-full mr-2 ${service?.status === 'available' ? 'bg-success' : service?.status === 'limited' ? 'bg-warning' : 'bg-error'}`} />
              {getStatusText(service?.status)}
            </div>
          </div>
        </div>
      </div>
      <p className="text-muted-foreground mb-4 leading-relaxed">
        {service?.description}
      </p>
      <div className="space-y-3 mb-6">
        <div className="flex items-center space-x-2 text-sm">
          <Icon name="Clock" size={16} className="text-muted-foreground" />
          <span className="text-foreground">
            <span className="font-medium">ระยะเวลาดำเนินการ:</span> {service?.processingTime}
          </span>
        </div>
        
        <div className="flex items-center space-x-2 text-sm">
          <Icon name="FileText" size={16} className="text-muted-foreground" />
          <span className="text-foreground">
            <span className="font-medium">เอกสารที่ต้องใช้:</span> {service?.requirements}
          </span>
        </div>

        {service?.fee && (
          <div className="flex items-center space-x-2 text-sm">
            <Icon name="CreditCard" size={16} className="text-muted-foreground" />
            <span className="text-foreground">
              <span className="font-medium">ค่าธรรมเนียม:</span> {service?.fee}
            </span>
          </div>
        )}
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        {service?.actionLink && service?.status === 'available' ? (
          <Link to={service?.actionLink} className="flex-1">
            <Button variant="default" fullWidth iconName="ArrowRight" iconPosition="right">
              {service?.actionText}
            </Button>
          </Link>
        ) : (
          <Button 
            variant="outline" 
            disabled={service?.status !== 'available'}
            fullWidth
            iconName="Info"
            iconPosition="left"
          >
            {service?.status === 'available' ? 'ข้อมูลเพิ่มเติม' : 'บริการไม่พร้อม'}
          </Button>
        )}
        
        {service?.infoLink && (
          <Button 
            variant="ghost" 
            iconName="HelpCircle" 
            iconPosition="left"
            className="sm:w-auto"
          >
            คำแนะนำ
          </Button>
        )}
      </div>
    </div>
  );
};

export default ServiceCard;